import React from 'react';

const TooltipIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.33594 7.32116C7.33594 7.14435 7.40618 6.97478 7.5312 6.84975C7.65622 6.72473 7.82579 6.65449 8.0026 6.65449C8.17942 6.65449 8.34898 6.72473 8.47401 6.84975C8.59903 6.97478 8.66927 7.14435 8.66927 7.32116V11.3212C8.66927 11.498 8.59903 11.6675 8.47401 11.7926C8.34898 11.9176 8.17942 11.9878 8.0026 11.9878C7.82579 11.9878 7.65622 11.9176 7.5312 11.7926C7.40618 11.6675 7.33594 11.498 7.33594 11.3212V7.32116ZM8.0026 4.03516C7.82579 4.03516 7.65622 4.10539 7.5312 4.23042C7.40618 4.35544 7.33594 4.52501 7.33594 4.70182C7.33594 4.87863 7.40618 5.0482 7.5312 5.17323C7.65622 5.29825 7.82579 5.36849 8.0026 5.36849C8.17942 5.36849 8.34898 5.29825 8.47401 5.17323C8.59903 5.0482 8.66927 4.87863 8.66927 4.70182C8.66927 4.52501 8.59903 4.35544 8.47401 4.23042C8.34898 4.10539 8.17942 4.03516 8.0026 4.03516Z'
        fill='#41415A'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.0026 1.33398C4.3206 1.33398 1.33594 4.31865 1.33594 8.00065C1.33594 11.6827 4.3206 14.6673 8.0026 14.6673C11.6846 14.6673 14.6693 11.6827 14.6693 8.00065C14.6693 4.31865 11.6846 1.33398 8.0026 1.33398ZM2.66927 8.00065C2.66927 9.41514 3.23117 10.7717 4.23137 11.7719C5.23156 12.7721 6.58812 13.334 8.0026 13.334C9.41709 13.334 10.7736 12.7721 11.7738 11.7719C12.774 10.7717 13.3359 9.41514 13.3359 8.00065C13.3359 6.58616 12.774 5.22961 11.7738 4.22941C10.7736 3.22922 9.41709 2.66732 8.0026 2.66732C6.58812 2.66732 5.23156 3.22922 4.23137 4.22941C3.23117 5.22961 2.66927 6.58616 2.66927 8.00065Z'
        fill='#41415A'
      />
    </svg>
  );
};

export default TooltipIcon;
